/* tslint:disable: ordered-imports*/
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
/* Modules */
import { AppCommonModule } from '@common/app-common.module';
import * as CommerceService from '@modules/commerce/services';
import { FiscalOnboardingSharedModule } from '@modules/fiscal-onboarding/fiscal-onboarding-shared.module';
import { OnboardingModule } from '@modules/onboarding/onboarding.module';

/* Components */
import * as navigationComponents from './components';
/* Containers */
import * as navigationContainers from './containers';
/* Guards */
import * as navigationGuards from './guards';
/* Layouts */
import * as appCommonLayouts from './layouts';
/* Services */
import * as navigationServices from './services';

@NgModule({
    // `FiscalOnboardingSharedModule`: badge de estado del ítem «Fiscal» del menú (recaudos v2).
    imports: [CommonModule, FormsModule, RouterModule, AppCommonModule, OnboardingModule, FiscalOnboardingSharedModule],
    declarations: [...navigationContainers.containers, ...navigationComponents.components, ...appCommonLayouts.layouts],
    exports: [...navigationContainers.containers, ...navigationComponents.components, ...appCommonLayouts.layouts],
    providers: [{ provide: 'window', useValue: window }],
})
export class NavigationModule {
    static forRoot(): ModuleWithProviders<NavigationModule> {
        return {
            ngModule: NavigationModule,
            providers: [...navigationServices.services, ...CommerceService.services, ...navigationGuards.guards],
        };
    }
}
